import { Button, Label, Modal, type ModalProps,Textarea } from 'flowbite-react';
import { CheckIcon, ListCheckIcon } from 'lucide-react';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';

interface FormData {
    contents: string;
}

export interface CitationImportModalProps extends ModalProps {
    onImport: (data: string[]) => void;
}

export const CitationImportModal = ({
    show,
    onImport,
    onClose
}: CitationImportModalProps) => {
    const { register, formState: { errors }, getValues } = useForm<FormData>({
        defaultValues: {
            contents: ''
        },
    });

    const handleImport = useCallback(() => {
        const values = getValues();
        const contents = values.contents.split('\n')
            .map((line) => line.trim())
            .filter((line) => line.length > 0);

        onImport(contents);
        onClose?.();
    }, [ onImport, onClose ]);

    return (
        <Modal show={show} size="2xl" onClose={onClose} popup>
            <Modal.Header>
                <span className="flex flex-row items-start md:items-center leading-5 justify-center gap-2 p-3 text-base md:text-lg font-semibold text-gray-800 dark:text-gray-400">
                    <ListCheckIcon size={20} className='flex-shrink-0' />
                    <span>Hromadné vložení použité literatury</span>
                </span>
            </Modal.Header>
            <Modal.Body>
                <div className='w-full mb-4'>
                    <Label htmlFor="source" className="block mb-1">Zadejte na každý řádek jednu položku:</Label>
                    <Textarea
                        id="source"
                        placeholder={[
                            'NOVÁK, Jan. Nové citace ISBN 1234567890.',
                            'STUDENT, Petr. Psaní diplomové práce ISBN 0987654321.',
                        ].join('\n')}
                        {...register('contents', {
                            maxLength: { value: 30000, message: 'Max. délka je 30000 znaků.' },
                            required: { value: true, message: 'Toto pole je povinné.' },
                        })}
                        rows={16}
                        className='grow w-full overflow-auto whitespace-pre'
                        color={errors.contents ? 'failure' : 'default'}
                        helperText={(
                            <>
                                {errors.contents && (
                                    <p>
                                        {errors.contents.message}
                                    </p>
                                )}
                            </>
                        )}
                    />
                </div>

                <div className='flex flex-col items-stretch gap-2'>
                    <div className='flex flex-row items-center justify-end gap-2'>
                        <Button
                            color="gray"
                            onClick={onClose}
                        >Zavřít</Button>

                        <div className='flex-grow' />

                        <Button
                            color='primary'
                            size='sm'
                            className='flex-shrink-0'
                            onClick={handleImport}
                        ><CheckIcon size={18} /> <span className='ml-2'>Vložit</span></Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};
